import { useState } from 'react'
import RoutesMap from 'route_control/RouteControl'
import { Form, InputGroup, Button, Card } from 'react-bootstrap'
import { useFormik } from 'formik'
import { KeyRound, UserRound, Eye, EyeOff } from 'lucide-react'
import { toast } from 'react-toastify'
import logo from 'assets/images/logo.png'
import { LoginSchema } from './ValidationSchema'
import { ButtonLoader } from 'components/loader'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { signIn, sidebar } from '../../../redux/slices/assets'
import { SessionManager } from 'utils'

export default function UserLoginForm(props) {

  const { setTogggle } = props

  const [spinner, setSpinner] = useState(false)
  const [showPassword, setShowPassword] = useState(false)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const initialValues = {
    phone: '',
    password: '',
  };

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
    initialValues: initialValues,
    validationSchema: LoginSchema,

    onSubmit: (values, action) => {
      // console.log(values)
      setSpinner(true)
      dispatch(signIn(values)).then((res) => signIn_user(res.payload, action))
    },
  })

  const signIn_user = (res, action) => {

    if (res?.status === 200) {

      SessionManager.setCookie('user_token', `Bearer ${res?.data?.data?.userResponse?.access_token}`, 7)
      SessionManager.setCookie('user', res?.data?.data && JSON.stringify(res?.data?.data?.userResponse), 7)

      toast.success("SignIn Successfully!!..", { position: "bottom-right" })

      dispatch(sidebar({ navigate })).then((res1) => sidebar_res(res1.payload))

    } else if (res?.status === 400) {
      setSpinner(false)
      toast.error(res?.data?.message, { position: "bottom-right" })
    } else if (res?.status === 500) {
      setSpinner(false)
      toast.error("Server error!!..", { position: "bottom-right" })
    } else {
      setSpinner(false)
      toast.error("Something went wrong!!..", { position: "bottom-right" })
    }
  }

  const sidebar_res = (res) => {
    if (res?.status === 200) {
      const permission = res?.data?.data?.attributes?.map(val => JSON.parse(val)).flat()
      SessionManager.setSession('permission', JSON.stringify(permission))
      navigate(RoutesMap.DASHBOARD.path)
      setSpinner(false)
    } else {
      setSpinner(false)
    }
  }

  return (
    <Card className="h-100 border-0 shadow" style={{ borderRadius: '16px', backgroundColor: '#ffffff', overflow: 'hidden' }}>
      <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} className='h-100 d-flex flex-column'>

        <div className="text-end px-4 pt-3 pb-2">
          <u className='fw-medium text-muted' style={{ cursor: 'pointer', fontSize: '13px', textDecorationColor: '#8c9269' }} onClick={() => setTogggle(true)}>Forget Password?</u>
        </div>

        <Card.Body className='px-4 px-sm-5 d-flex flex-column justify-content-center'>
          <div className='text-center mb-2'>
            <img src={logo} alt="logo" className='img-fluid mb-2' style={{ height: '60px', objectFit: 'contain' }} />
            <h4 className='fw-bold mb-1' style={{ color: '#001529' }}>Sign In</h4>
            <p className="text-muted" style={{ fontSize: '14px' }}>Welcome back! Please enter your details.</p>
          </div>

          <div className='mb-1'>
            <Form.Label className='fw-semibold mb-1 text-dark' style={{ fontSize: '13px' }}>Mobile / Email</Form.Label>
            <InputGroup
              className="rounded-3 shadow-sm"
              style={{ border: '1px solid #e1e5eb', overflow: 'hidden', backgroundColor: '#f9fafb' }}
            >
              <InputGroup.Text id="phone" className="bg-transparent border-0 text-muted px-3">
                <UserRound size={18} strokeWidth={2} />
              </InputGroup.Text>
              <Form.Control
                className='login-input border-0 bg-transparent shadow-none px-0'
                placeholder="Enter your mobile / email"
                aria-label="Phone"
                aria-describedby="phone"
                name='phone'
                value={values.phone || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                style={{ fontSize: '14px', height: '45px' }}
              />
            </InputGroup>
            {errors.phone && touched.phone ? (<div className='text-danger mt-1 ms-1' style={{ fontSize: '12px' }}>{errors.phone}</div>) : null}
          </div>

          <div className='mb-1'>
            <Form.Label className='fw-semibold mb-1 text-dark' style={{ fontSize: '13px' }}>Password</Form.Label>
            <InputGroup
              className="rounded-3 shadow-sm"
              style={{ border: '1px solid #e1e5eb', overflow: 'hidden', backgroundColor: '#f9fafb' }}
            >
              <InputGroup.Text id="password" className="bg-transparent border-0 text-muted px-3">
                <KeyRound size={18} strokeWidth={2} />
              </InputGroup.Text>
              <Form.Control
                type={showPassword ? 'text' : 'password'}
                className='login-input border-0 bg-transparent shadow-none px-0'
                placeholder="Enter your password"
                aria-label="Password"
                aria-describedby="password"
                name='password'
                value={values.password || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                style={{ fontSize: '14px', height: '45px' }}
              />
              <InputGroup.Text
                id="password"
                onClick={() => setShowPassword(!showPassword)}
                className="bg-transparent border-0 text-muted px-3"
                style={{ cursor: 'pointer' }}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </InputGroup.Text>
            </InputGroup>
            {errors.password && touched.password ? (<div className='text-danger mt-1 ms-1' style={{ fontSize: '12px' }}>{errors.password}</div>) : null}
          </div>

          <div className="mt-2 text-center">
            <Button type='submit' className='w-100 login_save_btn shadow text-uppercase fw-bold rounded-3' style={{ letterSpacing: '1px' }} disabled={spinner}>
              {spinner ? <ButtonLoader /> : 'Sign In'}
            </Button>
          </div>
        </Card.Body>

        <Card.Footer className="bg-light border-top-0 px-4 py-2 text-center">
          <span style={{ fontSize: '12px' }} className='text-muted'>
            By continuing, you agree to the <br />
            <u className='fw-medium text-dark' style={{ cursor: 'pointer', textDecorationColor: '#8c9269' }}>Terms of Service</u> and <u className='fw-medium text-dark' style={{ cursor: 'pointer', textDecorationColor: '#8c9269' }}>Privacy Policy</u>
          </span>
        </Card.Footer>

      </Form>
    </Card>
  )
}